<template>
  <div class="video-message">
    <BaseMessageBubble class="BaseMessageBubble">
      <video :src="options.src ? options.src : options.payload.remoteVideoUrl" controls autoplay></video>
    </BaseMessageBubble>
    <BaseProgress v-if="options.progress && options.progress !== 100" :percentage="options.progress" :color="options.progress === 100 ? '#67c23a' : '#409eff'"></BaseProgress>
  </div>
</template>

<script>
import BaseMessageBubble from './BaseMessageBubble.vue'
import BaseProgress from './BaseProgress.vue'
export default {
  name: 'baseVideoMessage',
  components: {
    BaseMessageBubble,
    BaseProgress
  },
  data () {
    return {}
  },
  props: {
    options: {
      type: Object,
      default: () => { }
    }
  }
}
</script>

<style>
.BaseMessageBubble > video {
  max-width: calc(80vw - 57px);
}
</style>
